import React, { useEffect } from "react";
import successImage from "../assets/images/In_progress_concept.jpg";

const SuccessPage = () => {
  useEffect(() => {
    const timer = setTimeout(() => {
      window.location = "https://mjc.edu.sa/";
    }, 3000);

    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="d-flex flex-column align-items-center justify-content-center" style={{ minHeight: "80vh", }}>
   
      <h3 className="text-success mb-3">✅ تم تقديم طلبك بنجاح</h3>
      <p className="text-muted">سيتم تحويلك إلى الصفحة الرئيسية خلال لحظات...</p>

      <div className="spinner-border text-success mt-4" role="status">
        <span className="visually-hidden">جارٍ التحويل...</span>
      </div>
    </div>
  );
};

export default SuccessPage;
